import {Grid} from '@albert-io/atomic';
import {refreshSession} from '@albert-io/mandark/authentication';
import React, {useEffect} from 'react';

import ChangePassword from 'client/components/ChangePassword/ChangePassword';
import {history} from 'client/history';

import {useChangePasswordLandingPageQuery} from './ChangePasswordLandingPage.queries.generated';

/**
 * ChangePasswordLandingPage
 * ==============
 *
 * The ChangePassword component appears on the landing page for
 * users whose token requires them to update their password.
 *
 * It returns an instance of ChangePassword, which returns an
 * instance of ResetPassword but with the addition of an "Old
 * Password" field, plus the necessary handlers for changes,
 * successful saving, and errors.
 *
 * When the user successfully updates their password, the below
 * handleSubmitCallback function will clear their token, refresh it
 * with a new one, and redirect them to the classes dashboard.
 */

function handleSubmitCallback() {
  refreshSession().then(() => {
    history.pushState(null, '/classes');
  });
}

interface ChangePasswordLandingPageProps {
  userId: string;
}

const ChangePasswordLandingPage = (props: ChangePasswordLandingPageProps) => {
  const {data, loading, error} = useChangePasswordLandingPageQuery();

  useEffect(() => {
    if (error) {
      history.pushState(null, '/error');
    }
  }, [error]);

  if (loading || error) {
    return null;
  }

  const isSchoolManaged = data?.currentUser?.isManagedUser ?? false;

  return (
    <Grid.Container>
      <Grid.Row justify='center'>
        <Grid.Col all={6} s={12}>
          <ChangePassword
            hideCloseBtn
            legend='Set your new password so you can keep learning!'
            onSubmitSuccess={handleSubmitCallback}
            shadow='default'
            checkOldPassword={!isSchoolManaged}
            {...props}
          />
        </Grid.Col>
      </Grid.Row>
    </Grid.Container>
  );
};

export default ChangePasswordLandingPage;
